import {
  ChevronLeftIcon,
  ChevronRightIcon,
  HomeIcon,
} from '@heroicons/react/20/solid'
import Link from 'next/link'

export const Breadcrumb = ({ pages, className }: BreadcrumbProps) => {
  const parentPage =
    pages.length > 1
      ? [...pages].reverse().find(p => p.href && p.href !== '#')
      : null

  return (
    <nav aria-label="Breadcrumb" className={`flex ${className || ''}`}>
      {/* Mobile: single "Back to parent" link */}
      {parentPage && (
        <Link
          prefetch={false}
          href={parentPage.href!}
          className="flex items-center gap-1 text-sm font-medium text-gray-600 hover:text-gray-800 md:hidden"
        >
          <ChevronLeftIcon aria-hidden className="size-4 shrink-0" />
          {parentPage.name}
        </Link>
      )}

      {/* Desktop: full breadcrumb trail */}
      <ol role="list" className="hidden md:flex md:items-center md:space-x-1">
        <li>
          <div>
            <Link
              prefetch={false}
              href="/"
              className="text-gray-400 hover:text-gray-500"
            >
              <HomeIcon aria-hidden="true" className="size-5 shrink-0" />
              <span className="sr-only">Home</span>
            </Link>
          </div>
        </li>
        {pages.map((page, index) => {
          const isCurrentPage = index === pages.length - 1
          return (
            <li key={page.name}>
              <div className="flex items-center">
                <ChevronRightIcon
                  aria-hidden="true"
                  className="size-5 shrink-0 text-gray-400"
                />
                {page.href && page.href !== '#' && !isCurrentPage ? (
                  <Link
                    prefetch={false}
                    href={page.href}
                    className="ml-1 text-base font-medium text-gray-600 hover:text-gray-800"
                  >
                    {page.name}
                  </Link>
                ) : (
                  <span
                    className="ml-1 text-base font-medium text-gray-400"
                    aria-current={isCurrentPage ? 'page' : undefined}
                  >
                    {page.name}
                  </span>
                )}
              </div>
            </li>
          )
        })}
      </ol>
    </nav>
  )
}

interface BreadcrumbProps {
  pages: {
    name: string
    href?: string
  }[]
  className?: string
}
